function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgIconStar2 = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 18 18"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "m8.715 0 2.848 5.636 6.152 1.091-4.059 4.509.812 6.764-5.753-3.346L2.891 18l1.059-6.764-4.235-4.509 6.2-1.091z",
  style: {
    fill: "#ddd"
  },
  transform: "translate(.285)"
}));
export default SvgIconStar2;